class AtRte extends HTMLElement {
  connectedCallback() {
    // Handle read more functionality
    if (this.dataset.readMore === 'true') {
      this.initReadMore()
    }
  }

  /**
   * Truncates HTML content to a specific word count while preserving HTML structure
   * @param {HTMLElement} element - The element containing HTML to truncate
   * @param {number} wordLimit - Maximum number of words to keep
   * @returns {string} Truncated HTML string with ellipsis
   */
  truncateHTML(element, wordLimit) {
    const clone = element.cloneNode(true)
    let wordCount = 0
    let truncated = false

    const walkNodes = (node) => {
      if (truncated) return false

      // If it's a text node, count and truncate words
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent
        const words = text.split(/\s+/).filter(word => word.length > 0)

        for (let i = 0; i < words.length; i++) {
          wordCount++
          if (wordCount > wordLimit) {
            // Truncate at this point
            const truncatedWords = words.slice(0, i)
            node.textContent = truncatedWords.join(' ') + '...'
            truncated = true
            return false
          }
        }
        return true
      }

      // If it's an element node, walk through children
      if (node.nodeType === Node.ELEMENT_NODE) {
        const children = Array.from(node.childNodes)
        for (let i = 0; i < children.length; i++) {
          const shouldContinue = walkNodes(children[i])
          if (!shouldContinue) {
            // Remove remaining siblings
            while (i + 1 < children.length) {
              node.removeChild(children[children.length - 1])
              children.pop()
            }
            return false
          }
        }
      }

      return true
    }

    walkNodes(clone)
    return clone.innerHTML
  }

  initReadMore() {
    const content = this.querySelector('.rte-read-more__content')
    const button = this.querySelector('[data-read-more-toggle]')

    if (!content || !button) {
      return
    }

    // Get word limit from data attribute (default to 70)
    const wordLimit = parseInt(this.dataset.wordLimit) || 70

    // Store original HTML for restoring on expand
    const originalHTML = content.innerHTML

    // Get text content and count words
    const textContent = content.textContent.trim()
    const words = textContent.split(/\s+/).filter(word => word.length > 0)
    const wordCount = words.length

    console.log('TEST:: Read more check - Words:', wordCount, 'Limit:', wordLimit)

    // Only show button if word count exceeds the limit
    if (wordCount <= wordLimit) {
      button.style.display = 'none'
      return
    }

    // Create truncated version preserving HTML structure
    const truncatedHTML = this.truncateHTML(content, wordLimit)

    // Show the button since we have enough content
    button.style.display = 'inline-block'

    // Initially show truncated content
    content.innerHTML = truncatedHTML
    content.classList.add('rte--collapsed')

    // Add click handler to toggle
    button.addEventListener('click', () => {
      const isCollapsed = content.classList.contains('rte--collapsed')
      const readMoreText = button.querySelector('.rte__read-more-text')
      const readLessText = button.querySelector('.rte__read-less-text')

      if (isCollapsed) {
        // Expand - restore original HTML
        content.innerHTML = originalHTML
        content.classList.remove('rte--collapsed')
        button.setAttribute('aria-expanded', 'true')
        readMoreText.style.display = 'none'
        readLessText.style.display = 'inline'
      } else {
        // Collapse - show truncated text
        content.innerHTML = truncatedHTML
        content.classList.add('rte--collapsed')
        button.setAttribute('aria-expanded', 'false')
        readMoreText.style.display = 'inline'
        readLessText.style.display = 'none'
      }
    })
  }
}

customElements.define('at-rte', AtRte)
